// extracted by mini-css-extract-plugin
export default {"homepage":"Homepage_homepage__3fE70"};